export default class PositionsSnippetError extends Error {}
